import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ROLE_AGENTE_CONSULTA, ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { HistoricoLimiteFundoCadastro } from 'src/app/model/limite-agente-financeiro.model';
import { QuestionarioAvaliacaoProjetoDTO } from 'src/app/model/questionario.model';
import { QuestionarioService } from 'src/app/questionario-fgenergia/questionario.service';
import Utils from 'src/app/shared/fgi-utils';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { LimiteService } from 'src/app/shared/services/limite.service';
// import { RecuperacaoCreditoService } from '../recuperacao-credito.service';


@Component({
    selector: 'app-limite-historico-pesquisa',
    templateUrl: './limite-historico-pesquisa.component.html',
    styleUrls: ['./limite-historico-pesquisa.component.scss'],
    standalone: false
})
export class LimiteHistoricoPesquisaComponent implements OnInit{

  private pesquisaForm: UntypedFormGroup;
  private pesquisado = false; // usado no html
  private valoresPesquisaForm: any;
  public historico: HistoricoLimiteFundoCadastro[] ;
  private atributosPaginacaoComponenteListagem: EntityPagedResult<HistoricoLimiteFundoCadastro>;
  private opcoesPaginacao: number[];
  public apenasAlteracoesManuais: boolean = false;
  private parametrosPesquisa: any = {};
  private totalObjetosRetornados: number;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loadingService: BnLoadingService,
    private service: LimiteService,
    private permissaoService: PermissaoService) {

  }

  ngOnInit() {
    this.valoresPesquisaForm = undefined;
    this.opcoesPaginacao = [5,10, 15, 20];
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };

    this.pesquisaForm = this.formBuilder.group({
      comentarios: null,
      dataCriacao: null,
      dataReferencia: null,
      usuarioResponsavel: null,
      valorTotalLimiteContratacao: null,
      valorTotalRecursosFundo: null,

    });

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      // this.construirFormulario();
    });

    this.buscar(false, false);  // renderiza lista automaticamente
    this.apenasAlteracoesManuais = false;


  }

  // private construirFormulario() {
  //   // const valoresSessao = sessionStorage.getItem('valoresPesquisaQuestionarioForm');
  //   // this.valoresPesquisaForm = valoresSessao ? JSON.parse(valoresSessao) : {};

  //   this.pesquisaForm.patchValue({
  //     comentarios: this.valoresPesquisaForm.comentarios ? this.valoresPesquisaForm.comentarios : null,
  //     dataCriacao: this.valoresPesquisaForm.dataCriacao ? new Date(this.valoresPesquisaForm.dataCriacao) : null,
  //     dataReferencia: this.valoresPesquisaForm.dataReferencia ? this.valoresPesquisaForm.dataReferencia : null,
  //     usuarioResponsavel: this.valoresPesquisaForm.usuarioResponsavel ? this.valoresPesquisaForm.usuarioResponsavel : null,
  //     valorTotalLimiteContratacao: this.valoresPesquisaForm.valorTotalLimiteContratacao ? this.valoresPesquisaForm.valorTotalLimiteContratacao : null,
  //     valorTotalRecursosFundo: this.valoresPesquisaForm.valorTotalRecursosFundo ? this.valoresPesquisaForm.valorTotalRecursosFundo : null,
  //   });

  // }
  changeCheck(apenasAlteracoesManuais:boolean){
    this.apenasAlteracoesManuais = apenasAlteracoesManuais;
    this.buscar(false, false);
  }

  mudancaPagina(novaPagina: EntityPagedResult<HistoricoLimiteFundoCadastro>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(false, false);
  }

  buscar(paginaVazia: boolean, voltarPagina1: boolean) {
    this.loadingService.bloqueiaTela();
    this.pesquisado = false;
    const params: any = {};

    const dataCriacao = this.pesquisaForm.get('dataCriacao').value;
    if (dataCriacao) {
      params.dataCriacao = dataCriacao.trim();
    }

    const comentarios = this.pesquisaForm.get('comentarios').value;
    if (comentarios) {
      params.comentarios = comentarios.trim();
    }

    const dataReferencia = this.pesquisaForm.get('dataReferencia').value;
    if (dataReferencia) {
      params.dataReferencia = dataReferencia.trim();
    }

    const usuarioResponsavel = this.pesquisaForm.get('usuarioResponsavel').value;
    if (usuarioResponsavel) {
      params.usuarioResponsavel = usuarioResponsavel.trim();
    }

    const valorTotalLimiteContratacao = this.pesquisaForm.get('valorTotalLimiteContratacao').value;
    if (valorTotalLimiteContratacao) {
      params.valorTotalLimiteContratacao = valorTotalLimiteContratacao.trim();
    }

    const valorTotalRecursosFundo = this.pesquisaForm.get('valorTotalRecursosFundo').value;
    if (valorTotalRecursosFundo) {
      params.valorTotalRecursosFundo = valorTotalRecursosFundo.trim();
    }

    this.parametrosPesquisa = JSON.parse(JSON.stringify(params));

    if (voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page = 1;
    }

    paginaVazia = Utils.verificaPaginaVazia(this.historico, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
    if (paginaVazia && !voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page = this.atributosPaginacaoComponenteListagem.pages;
    }

    params.pagina = this.atributosPaginacaoComponenteListagem.page ;
    params.limite = this.atributosPaginacaoComponenteListagem.pageSize;
    params.apenasAlteracoesManuais = this.apenasAlteracoesManuais;
    this.service.getHistoricoLimiteFundoTrancheAtual(params)
      .subscribe(response => {
        this.historico = response ? response.resultados : undefined;
        this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
        this.totalObjetosRetornados = this.atributosPaginacaoComponenteListagem.count;
        this.pesquisado = true;
        this.loadingService.liberaTela();

        paginaVazia = Utils.verificaPaginaVazia(this.historico, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
        if (paginaVazia && !voltarPagina1) {
          this.buscar(false, true);
        }

      });
  }

  // limpar() {
  //   this.pesquisado = false;
  //   this.pesquisaForm.reset();
  //   this.historico = [];
  // }

}

